import React from 'react';
import InputBase from '@material-ui/core/InputBase';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
var useStyles = makeStyles(function (theme) { return ({
    root: function (props) { return ({
        fontSize: theme.typography.fontSize || '12px',
        maxWidth: props.width || 'auto',
        borderRadius: theme.shape.borderRadius || 3,
        padding: '4px',
        position: 'unset',
    }); },
    bordered: {
        border: function (props) {
            return props.bordered ? "1px solid ".concat(theme.commonSettings.borderColor) : '1px solid transparent';
        },
    },
    error: function () { return ({
        border: '1px solid red',
    }); },
}); });
/**
 * @deprecated
 * Use `TextAreaInput` to render a text area input inside your project
 */
function TextAreaInput(props) {
    var className = props.className, onChange = props.onChange, onBlur = props.onBlur, value = props.value, name = props.name, placeholder = props.placeholder, disabled = props.disabled, defaultValue = props.defaultValue, rows = props.rows, isErrorField = props.isErrorField, fullWidth = props.fullWidth;
    var classes = useStyles(props);
    return (React.createElement(InputBase, { multiline: true, value: value, onChange: onChange, onBlur: onBlur, name: name, placeholder: placeholder, disabled: disabled, fullWidth: fullWidth, classes: {
            root: classNames(classes.root, classes.bordered, className),
            error: classes.error,
        }, defaultValue: defaultValue, rows: rows, error: isErrorField }));
}
TextAreaInput.defaultProps = {
    rows: 3,
    width: 'auto',
    required: false,
    disabled: false,
    name: '',
};
export default TextAreaInput;
//# sourceMappingURL=TextAreaInput.js.map